import { Injectable } from '@angular/core';
import { AppService, BASE_URL_API } from '../../../app.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UploadService extends AppService{

  constructor(http: HttpClient) {
    super(http);
  }

  UploadImagem(name:string, file: File) :Observable<Object>{
   
    const form = new FormData();

    form.append('name',name);
    form.append('file',file);
    this.endpoint = `${BASE_URL_API}/upload`;
    console.log(this.endpoint);
    console.log(form);
    return this.post(this.endpoint,form);
  }
}
